import React, { useEffect } from 'react';
import { useField } from 'react-final-form';

import PrimaryButton, { SecondaryButton } from '@common/button';
import ErrorMessage from '@common/fields/_common/errorMessage';
import { useScopedTranslation } from '@common/utils/hooks/useScopedTranslation';
import { CallbackQuery_context_callback_buttons as Button } from '@typings/api';

import Section from './Section';
import SectionHeader from './SectionHeader';

interface Props {
  buttons: Button[];
  isSelfServicing?: boolean;
}

function CallbackHourField({ buttons = [], isSelfServicing }: Props) {
  const { t } = useScopedTranslation();
  const {
    input: { onChange, value: fieldValue },
    meta: { error, touched },
  } = useField('callbackHours');

  useEffect(() => {
    if (buttons.length === 1) {
      onChange(buttons[0].value);
    }
  }, [buttons]);

  if (buttons.length <= 1) {
    return null;
  }

  return (
    <Section>
      <SectionHeader>
        {isSelfServicing
          ? t('selfservicing:referral_form.callback_time.question')
          : t('referral_form.callback_time.question')}
      </SectionHeader>
      <div className="space-y-4">
        {buttons.map((button) => {
          const { label, value } = button;

          if (value === fieldValue) {
            return (
              <PrimaryButton key={value} type="button">
                {t(`referral_form.${label}`)}
              </PrimaryButton>
            );
          }

          return (
            <SecondaryButton
              key={value}
              onClick={() => onChange(value)}
              type="button"
            >
              {t(`referral_form.${label}`)}
            </SecondaryButton>
          );
        })}
        {touched && error && <ErrorMessage>{error}</ErrorMessage>}
      </div>
    </Section>
  );
}

export default CallbackHourField;
